import { Routes } from '@angular/router';
import { ScormViewerComponent } from './scorm-viewer/scorm-viewer.component';
import { AuthGuardService } from 'src/services/auth-guard.service';
import { unsavedChangesGuard } from 'src/services/unsaved-changes.guard';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { SilentCallbackComponent } from './silent-callback/silent-callback.component';
import { ScormsListComponent } from './scorms-list/scorms-list.component';
import { TrackingConsoleComponent } from './tracking-console/tracking-console.component';
import { TableauDeBordComponent } from './tableau-de-bord/tableau-de-bord.component';
import { UtilisateursManagmentComponent } from './tableau-de-bord/utilisateurs-managment/utilisateurs-managment.component';
import { UtilisateurEditComponent } from './tableau-de-bord/utilisateurs-managment/utilisateur-edit/utilisateur-edit.component';
import { SelectionEntiteComponent } from './selection-entite/selection-entite.component';
import { EtiquettesManagmentComponent } from './tableau-de-bord/etiquettes-managment/etiquettes-managment.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { RootSelectionEntiteComponent } from './root-selection-entite/root-selection-entite.component';
import { UtilisateursRootManagmentComponent } from './tableau-de-bord/utilisateurs-root-managment/utilisateurs-root-managment.component';
import { BibliothequesManagmentComponent } from './tableau-de-bord/bibliotheques-managment/bibliotheques-managment.component';
import { OrganisationsManagmentComponent } from './tableau-de-bord/organisations-managment/organisations-managment.component';
import { ContenusManagementComponent } from './tableau-de-bord/contenus-management/contenus-management.component';
import { ContenusCompleteComponent } from './tableau-de-bord/contenus-management/contenus-complete/contenus-complete.component';
import { ContenusEvenementSessionComponent } from './tableau-de-bord/contenus-management/contenus-evenement-session/contenus-evenement-session.component';
import { PackagesPersoManagmentComponent } from './tableau-de-bord/packages-perso-managment/packages-perso-managment.component';
import { CreatePackagePersoComponent } from './tableau-de-bord/packages-perso-managment/create-package-perso/create-package-perso.component';
import { EditPackagePersoComponent } from './tableau-de-bord/packages-perso-managment/edit-package-perso/edit-package-perso.component';
import { ProfilUtilisateurComponent } from './profil-utilisateur/profil-utilisateur.component';
import { DocumentUtilisateurComponent } from './profil-utilisateur/document-utilisateur/document-utilisateur.component';
import { ParametreUtilisateurComponent } from './profil-utilisateur/parametre-utilisateur/parametre-utilisateur.component';
import { ListDocumentComponent } from './profil-utilisateur/document-utilisateur/list-document/list-document.component';
import { AjouterDocumentComponent } from './profil-utilisateur/document-utilisateur/ajouter-document/ajouter-document.component';
import { ParcoursFormationManagmentComponent } from './tableau-de-bord/parcours-formation-managment/parcours-formation-managment.component';
import { CreateEditParcoursFormationComponent } from './tableau-de-bord/parcours-formation-managment/create-edit-parcours-formation/create-edit-parcours-formation.component';
import { CertificatManagmentComponent } from './tableau-de-bord/certificat-managment/certificat-managment.component';
import { CreateEditBibliothequeComponent } from './tableau-de-bord/bibliotheques-managment/create-edit-bibliotheque/create-edit-bibliotheque.component';
import { GroupesFormationManagmentComponent } from './tableau-de-bord/groupes-formation-managment/groupes-formation-managment.component';
import { IndexFormationComponent } from './tableau-de-bord/index-formation/index-formation.component';
import { IndexFormationDetailComponent } from './tableau-de-bord/index-formation/index-formation-detail/index-formation-detail.component';
import { ParametresOrganisationsManagmentComponent } from './tableau-de-bord/parametres-organisations-managment/parametres-organisations-managment.component';
import { DiffusionManagmentComponent } from './tableau-de-bord/diffusion-managment/diffusion-managment.component';
import { NovoPageErreurComponent } from './novo-page-erreur/novo-page-erreur.component';
import { AdministrationAvanceeManagmentComponent } from './tableau-de-bord/administration-avancee-managment/administration-avancee-managment.component';
import { VimeoPlayerComponent } from './vimeo-player/vimeo-player.component';
import { AideEtSoutienComponent } from './aide-et-soutien/aide-et-soutien.component';
import { NousContacterComponent } from './aide-et-soutien/nous-contacter/nous-contacter.component';
import { TutorielsComponent } from './aide-et-soutien/tutoriels/tutoriels.component';
import { NotesDeVersionComponent } from './aide-et-soutien/notes-de-version/notes-de-version.component';
import { ParametreEntiteComponent } from './tableau-de-bord/parametre-entite/parametre-entite.component';
import { RapportsComponent } from './tableau-de-bord/rapports/rapports.component';
import { RapportsParcoursFormationComponent } from './tableau-de-bord/rapports-parcours-formation/rapports-parcours-formation.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'accueil',
    pathMatch: 'full'
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'novo-page-erreur',
    component: NovoPageErreurComponent
  },
  {
    path: 'accueil',
    component: ScormsListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'selection-entite',
    component: SelectionEntiteComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'root-selection-entite',
    component: RootSelectionEntiteComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'scormviewer/:scormContentId',
    component: ScormViewerComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'scormviewer/:scormContentId/formationGroupe/:formationGroupeId',
    component: ScormViewerComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'tracking-console',
    component: TrackingConsoleComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'profil-utilisateur',
    component: ProfilUtilisateurComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'tableau-de-bord',
    component: TableauDeBordComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'utilisateurs-managment',
    component: UtilisateursManagmentComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'utilisateurs-root-managment',
    component: UtilisateursRootManagmentComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'etiquettes-managment',
    component: EtiquettesManagmentComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'scorm-perso-managment',
    component: PackagesPersoManagmentComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'scorm-perso-managment/create',
    component: CreatePackagePersoComponent,
    canActivate: [AuthGuardService],
    canDeactivate: [unsavedChangesGuard]
  },
  {
    path: 'scorm-perso-managment/create/:id',
    component: CreatePackagePersoComponent,
    canActivate: [AuthGuardService],
    canDeactivate: [unsavedChangesGuard]
  },
  {
    path: 'scorm-perso-managment/edit/:id',
    component: EditPackagePersoComponent,
    canActivate: [AuthGuardService],
    canDeactivate: [unsavedChangesGuard]
  },
  {
    path: 'bibliotheques-managment',
    component: BibliothequesManagmentComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'bibliotheques/create',
    component: CreateEditBibliothequeComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'bibliotheques/edit/:id',
    component: CreateEditBibliothequeComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'parcours-formation-managment',
    component: ParcoursFormationManagmentComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'parcours-formation/create',
    component: CreateEditParcoursFormationComponent,
    canActivate: [AuthGuardService],

  },
  {
    path: 'parcours-formation/edit/:id',
    component: CreateEditParcoursFormationComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'organisations-managment',
    component: OrganisationsManagmentComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'certificats-managment',
    component: CertificatManagmentComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'groupes-formation-managment',
    component: GroupesFormationManagmentComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'contenus-managment/:provenance', component: ContenusManagementComponent, canActivate: [AuthGuardService],
    children: [
      {
        path: 'complete/:id',
        component: ContenusCompleteComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'complete',
        component: ContenusCompleteComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'encours/:id',
        component: ContenusCompleteComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'encours',
        component: ContenusCompleteComponent,
        canActivate: [AuthGuardService]
      }
    ]
  },
  {
    path: 'contenus-managment/session-evenement/:id', component: ContenusEvenementSessionComponent, canActivate: [AuthGuardService]
  },
  {
    path: 'index-formation',
    component: IndexFormationComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'index-formation/:nomPackage',
    component: IndexFormationDetailComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'document-utlisateur', component: DocumentUtilisateurComponent, canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        component: ListDocumentComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'list',
        component: ListDocumentComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'ajouter/:id',
        component: AjouterDocumentComponent,
        canActivate: [AuthGuardService]
      }
    ]
  },
  {
    path: 'parametre-utlisateur',
    component: ParametreUtilisateurComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'edit-user/:id',
    component: UtilisateurEditComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'auth-callback',
    component: AuthCallbackComponent,
  },
  {
    path: 'silent-callback',
    component: SilentCallbackComponent,
  },
  {
    path: 'parametres-organisations-managment',
    component: ParametresOrganisationsManagmentComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'administration-avancee-managment',
    component: AdministrationAvanceeManagmentComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'diffusion-managment',
    component: DiffusionManagmentComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'aide-et-soutien',
    component: AideEtSoutienComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'aide-et-soutien/nous-contacter',
    component: NousContacterComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'aide-et-soutien/tutoriels',
    component: TutorielsComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'aide-et-soutien/notes-de-version',
    component: NotesDeVersionComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'player',
    component: VimeoPlayerComponent
  },
  {
    path: 'parametre-entite',
    component: ParametreEntiteComponent
  },
  {
    path: 'rapports',
    component: RapportsComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'formations',
        component: ContenusManagementComponent,
        children: [
          { path: 'complete', component: ContenusCompleteComponent, canActivate: [AuthGuardService] },
          { path: 'encours', component: ContenusCompleteComponent, canActivate: [AuthGuardService] },
          { path: '', redirectTo: 'complete', pathMatch: 'full' }
        ]
      },
      {
        path: 'parcours-formation',
        component: RapportsParcoursFormationComponent,
        canActivate: [AuthGuardService]
      }
    ]
  }
];
